(() => {
  // node_modules/embla-carousel/embla-carousel.esm.js
  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function Alignment(align, viewSize) {
    var predefined = {
      start,
      center,
      end
    };
    function start() {
      return 0;
    }
    function center(n) {
      return end(n) / 2;
    }
    function end(n) {
      return viewSize - n;
    }
    function percent() {
      return viewSize * Number(align);
    }
    function measure(n) {
      if (typeof align === "number")
        return percent();
      return predefined[align](n);
    }
    var self = {
      measure
    };
    return self;
  }
  function Animation(callback) {
    var animationFrame = 0;
    function ifAnimating(active, cb) {
      return function () {
        if (active === !!animationFrame)
          cb();
      };
    }
    function start() {
      animationFrame = window.requestAnimationFrame(callback);
    }
    function stop() {
      window.cancelAnimationFrame(animationFrame);
      animationFrame = 0;
    }
    var self = {
      proceed: ifAnimating(true, start),
      start: ifAnimating(false, start),
      stop: ifAnimating(true, stop)
    };
    return self;
  }
  function Axis(axis, contentDirection) {
    var scroll = axis === "y" ? "y" : "x";
    var cross = axis === "y" ? "x" : "y";
    var startEdge = getStartEdge();
    var endEdge = getEndEdge();
    function measureSize(rect) {
      var width = rect.width, height = rect.height;
      return scroll === "x" ? width : height;
    }
    function getStartEdge() {
      if (scroll === "y")
        return "top";
      return contentDirection === "rtl" ? "right" : "left";
    }
    function getEndEdge() {
      if (scroll === "y")
        return "bottom";
      return contentDirection === "rtl" ? "left" : "right";
    }
    var self = {
      scroll,
      cross,
      startEdge,
      endEdge,
      measureSize
    };
    return self;
  }
  function Limit(min, max) {
    var length = Math.abs(min - max);
    function reachedMin(n) {
      return n < min;
    }
    function reachedMax(n) {
      return n > max;
    }
    function reachedAny(n) {
      return reachedMin(n) || reachedMax(n);
    }
    function constrain(n) {
      if (!reachedAny(n))
        return n;
      return reachedMin(n) ? min : max;
    }
    function removeOffset(n) {
      if (!length)
        return n;
      return n - length * Math.ceil((n - max) / length);
    }
    var self = {
      constrain,
      length,
      max,
      min,
      reachedAny,
      reachedMax,
      reachedMin,
      removeOffset
    };
    return self;
  }
  function Counter(max, start, loop) {
    var _a = Limit(0, max), min = _a.min, constrain = _a.constrain;
    var loopEnd = max + 1;
    var counter = withinLimit(start);
    function withinLimit(n) {
      return !loop ? constrain(n) : Math.abs((loopEnd + n) % loopEnd);
    }
    function get() {
      return counter;
    }
    function set(n) {
      counter = withinLimit(n);
      return self;
    }
    function add(n) {
      return set(get() + n);
    }
    function clone() {
      return Counter(max, get(), loop);
    }
    var self = {
      add,
      clone,
      get,
      set,
      min,
      max
    };
    return self;
  }
  function Direction(direction) {
    var sign = direction === "rtl" ? -1 : 1;
    function applyTo(n) {
      return n * sign;
    }
    var self = {
      applyTo
    };
    return self;
  }
  function EventStore() {
    var listeners = [];
    function add(node, type, handler, options2) {
      if (options2 === void 0) {
        options2 = false;
      }
      node.addEventListener(type, handler, options2);
      listeners.push(function () {
        return node.removeEventListener(type, handler, options2);
      });
      return self;
    }
    function removeAll() {
      listeners = listeners.filter(function (remove) {
        return remove();
      });
      return self;
    }
    var self = {
      add,
      removeAll
    };
    return self;
  }
  function Vector1D(value) {
    var vector = value;
    function get() {
      return vector;
    }
    function set(n) {
      vector = readNumber(n);
      return self;
    }
    function add(n) {
      vector += readNumber(n);
      return self;
    }
    function subtract(n) {
      vector -= readNumber(n);
      return self;
    }
    function multiply(n) {
      vector *= n;
      return self;
    }
    function divide(n) {
      vector /= n;
      return self;
    }
    function normalize() {
      if (vector !== 0)
        divide(vector);
      return self;
    }
    function readNumber(n) {
      return typeof n === "number" ? n : n.get();
    }
    var self = {
      add,
      divide,
      get,
      multiply,
      normalize,
      set,
      subtract
    };
    return self;
  }
  function map(value, iStart, iStop, oStart, oStop) {
    return oStart + (oStop - oStart) * ((value - iStart) / (iStop - iStart));
  }
  function mathSign(n) {
    return !n ? 0 : n / Math.abs(n);
  }
  function deltaAbs(valueB, valueA) {
    return Math.abs(valueB - valueA);
  }
  function factorAbs(valueB, valueA) {
    if (valueB === 0 || valueA === 0)
      return 0;
    if (Math.abs(valueB) <= Math.abs(valueA))
      return 0;
    var diff = deltaAbs(Math.abs(valueB), Math.abs(valueA));
    return Math.abs(diff / valueB);
  }
  function roundToDecimals(decimalPoints) {
    var pow = Math.pow(10, decimalPoints);
    return function (n) {
      return Math.round(n * pow) / pow;
    };
  }
  function debounce(callback, time) {
    var timeout = 0;
    return function () {
      window.clearTimeout(timeout);
      timeout = window.setTimeout(callback, time) || 0;
    };
  }
  function groupArray(array, size) {
    var groups = [];
    for (var i = 0; i < array.length; i += size) {
      groups.push(array.slice(i, i + size));
    }
    return groups;
  }
  function arrayKeys(array) {
    return Object.keys(array).map(Number);
  }
  function arrayLast(array) {
    return array[lastIndex(array)];
  }
  function lastIndex(array) {
    return Math.max(0, array.length - 1);
  }
  function removeClass(node, className) {
    var cl = node.classList;
    if (className && cl.contains(className))
      cl.remove(className);
  }
  function addClass(node, className) {
    var cl = node.classList;
    if (className && !cl.contains(className))
      cl.add(className);
  }
  function DragHandler(axis, direction, rootNode, target, dragFree, dragTracker, location, animation, scrollTo, scrollBody, scrollTarget, index, events, loop, skipSnaps) {
    var scrollAxis = axis.scroll, crossAxis = axis.cross;
    var focusNodes = ["INPUT", "SELECT", "TEXTAREA"];
    var startScroll = Vector1D(0);
    var startCross = Vector1D(0);
    var dragStartPoint = Vector1D(0);
    var activationEvents = EventStore();
    var interactionEvents = EventStore();
    var snapForceBoost = {
      mouse: 2.5,
      touch: 3.5
    };
    var freeForceBoost = {
      mouse: 5,
      touch: 7
    };
    var baseSpeed = dragFree ? 5 : 16;
    var baseMass = 1;
    var dragThreshold = 20;
    var pointerIsDown = false;
    var preventScroll = false;
    var preventClick = false;
    var isMouse = false;
    function addActivationEvents() {
      var node = rootNode;
      activationEvents.add(node, "touchmove", function () {
        return void 0;
      }).add(node, "touchend", function () {
        return void 0;
      }).add(node, "touchstart", down).add(node, "mousedown", down).add(node, "touchcancel", up).add(node, "contextmenu", up).add(node, "click", click);
    }
    function addInteractionEvents() {
      var node = !isMouse ? rootNode : document;
      interactionEvents.add(node, "touchmove", move).add(node, "touchend", up).add(node, "mousemove", move).add(node, "mouseup", up);
    }
    function removeAllEvents() {
      activationEvents.removeAll();
      interactionEvents.removeAll();
    }
    function isFocusNode(node) {
      var name = node.nodeName || "";
      return focusNodes.indexOf(name) > -1;
    }
    function forceBoost() {
      var boost = dragFree ? freeForceBoost : snapForceBoost;
      var type = isMouse ? "mouse" : "touch";
      return boost[type];
    }
    function allowedForce(force, targetChanged) {
      var next = index.clone().add(mathSign(force) * -1);
      var isEdge = next.get() === index.min || next.get() === index.max;
      var baseForce = scrollTarget.byDistance(force, !dragFree).distance;
      if (dragFree || Math.abs(force) < dragThreshold)
        return baseForce;
      if (!loop && isEdge)
        return baseForce * 0.6;
      if (skipSnaps && targetChanged)
        return baseForce * 0.5;
      return scrollTarget.byIndex(next.get(), 0).distance;
    }
    function down(evt) {
      isMouse = evt.type === "mousedown";
      if (isMouse && evt.button !== 0)
        return;
      var isMoving = deltaAbs(target.get(), location.get()) >= 2;
      var clearPreventClick = isMouse || !isMoving;
      var isNotFocusNode = !isFocusNode(evt.target);
      var preventDefault = isMoving || isMouse && isNotFocusNode;
      pointerIsDown = true;
      dragTracker.pointerDown(evt);
      dragStartPoint.set(target);
      target.set(location);
      scrollBody.useBaseMass().useSpeed(80);
      addInteractionEvents();
      startScroll.set(dragTracker.readPoint(evt, scrollAxis));
      startCross.set(dragTracker.readPoint(evt, crossAxis));
      events.emit("pointerDown");
      if (clearPreventClick)
        preventClick = false;
      if (preventDefault)
        evt.preventDefault();
    }
    function move(evt) {
      if (!preventScroll && !isMouse) {
        if (!evt.cancelable)
          return up();
        var moveScroll = dragTracker.readPoint(evt, scrollAxis).get();
        var moveCross = dragTracker.readPoint(evt, crossAxis).get();
        var diffScroll = deltaAbs(moveScroll, startScroll.get());
        var diffCross = deltaAbs(moveCross, startCross.get());
        preventScroll = diffScroll > diffCross;
        if (!preventScroll && !preventClick)
          return up();
      }
      var diff = dragTracker.pointerMove(evt);
      if (!preventClick && diff)
        preventClick = true;
      animation.start();
      target.add(direction.applyTo(diff));
      evt.preventDefault();
    }
    function up() {
      var currentLocation = scrollTarget.byDistance(0, false);
      var targetChanged = currentLocation.index !== index.get();
      var rawForce = dragTracker.pointerUp() * forceBoost();
      var force = allowedForce(direction.applyTo(rawForce), targetChanged);
      var forceFactor = factorAbs(rawForce, force);
      var isMoving = deltaAbs(target.get(), dragStartPoint.get()) >= 0.5;
      var isVigorous = targetChanged && forceFactor > 0.75;
      var isBelowThreshold = Math.abs(rawForce) < dragThreshold;
      var speed = isVigorous ? 10 : baseSpeed;
      var mass = isVigorous ? baseMass + 2.5 * forceFactor : baseMass;
      if (isMoving && !isMouse)
        preventClick = true;
      preventScroll = false;
      pointerIsDown = false;
      interactionEvents.removeAll();
      scrollBody.useSpeed(isBelowThreshold ? 9 : speed).useMass(mass);
      scrollTo.distance(force, !dragFree);
      isMouse = false;
      events.emit("pointerUp");
    }
    function click(evt) {
      if (preventClick)
        evt.preventDefault();
    }
    function clickAllowed() {
      return !preventClick;
    }
    function pointerDown() {
      return pointerIsDown;
    }
    var self = {
      addActivationEvents,
      clickAllowed,
      pointerDown,
      removeAllEvents
    };
    return self;
  }
  function DragTracker(axis, pxToPercent) {
    var scrollAxis = axis.scroll;
    var coords = {
      x: "clientX",
      y: "clientY"
    };
    var startDrag = Vector1D(0);
    var diffDrag = Vector1D(0);
    var lastDrag = Vector1D(0);
    var pointValue = Vector1D(0);
    var trackInterval = 10;
    var trackLength = 5;
    var trackTime = 100;
    var trackPoints = [];
    var lastMoveTime = new Date().getTime();
    var isMouse = false;
    function readPoint(evt, type) {
      isMouse = !evt.touches;
      var c = coords[type];
      var value = isMouse ? evt[c] : evt.touches[0][c];
      return pointValue.set(value);
    }
    function pointerDown(evt) {
      var point = readPoint(evt, scrollAxis);
      startDrag.set(point);
      lastDrag.set(point);
      return pxToPercent.measure(startDrag.get());
    }
    function pointerMove(evt) {
      var point = readPoint(evt, scrollAxis);
      var nowTime = new Date().getTime();
      var diffTime = nowTime - lastMoveTime;
      if (diffTime >= trackInterval) {
        if (diffTime >= trackTime)
          trackPoints = [];
        trackPoints.push(point.get());
        lastMoveTime = nowTime;
      }
      diffDrag.set(point).subtract(lastDrag);
      lastDrag.set(point);
      return pxToPercent.measure(diffDrag.get());
    }
    function pointerUp() {
      var nowTime = new Date().getTime();
      var diffTime = nowTime - lastMoveTime;
      var currentPoint = lastDrag.get();
      var force = trackPoints.slice(-trackLength).map(function (trackPoint) {
        return currentPoint - trackPoint;
      }).sort(function (p1, p2) {
        return Math.abs(p1) < Math.abs(p2) ? 1 : -1;
      })[0];
      lastDrag.set(diffTime > trackTime || !force ? 0 : force);
      trackPoints = [];
      return pxToPercent.measure(lastDrag.get());
    }
    var self = {
      pointerDown,
      pointerMove,
      pointerUp,
      readPoint
    };
    return self;
  }
  function PxToPercent(viewInPx) {
    var totalPercent = 100;
    function measure(n) {
      if (viewInPx === 0)
        return 0;
      return n / viewInPx * totalPercent;
    }
    var self = {
      measure,
      totalPercent
    };
    return self;
  }
  function ScrollBody(location, baseSpeed, baseMass) {
    var roundToTwoDecimals = roundToDecimals(2);
    var velocity = Vector1D(0);
    var acceleration = Vector1D(0);
    var attraction = Vector1D(0);
    var attractionDirection = 0;
    var speed = baseSpeed;
    var mass = baseMass;
    function update() {
      velocity.add(acceleration);
      location.add(velocity);
      acceleration.multiply(0);
    }
    function applyForce(v) {
      v.divide(mass);
      acceleration.add(v);
    }
    function seek(v) {
      attraction.set(v).subtract(location);
      var magnitude = map(attraction.get(), 0, 100, 0, speed);
      attractionDirection = mathSign(attraction.get());
      attraction.normalize().multiply(magnitude).subtract(velocity);
      applyForce(attraction);
      return self;
    }
    function settle(v) {
      var diff = v.get() - location.get();
      var hasSettled = !roundToTwoDecimals(diff);
      if (hasSettled)
        location.set(v);
      return hasSettled;
    }
    function direction() {
      return attractionDirection;
    }
    function useBaseSpeed() {
      return useSpeed(baseSpeed);
    }
    function useBaseMass() {
      return useMass(baseMass);
    }
    function useSpeed(n) {
      speed = n;
      return self;
    }
    function useMass(n) {
      mass = n;
      return self;
    }
    var self = {
      direction,
      seek,
      settle,
      update,
      useBaseMass,
      useBaseSpeed,
      useMass,
      useSpeed
    };
    return self;
  }
  function ScrollBounds(limit, location, target, scrollBody) {
    var pullBackThreshold = 10;
    var disabled = false;
    function shouldConstrain() {
      if (disabled)
        return false;
      if (!limit.reachedAny(target.get()))
        return false;
      if (!limit.reachedAny(location.get()))
        return false;
      return true;
    }
    function constrain(pointerDown) {
      if (!shouldConstrain())
        return;
      var friction = pointerDown ? 0.7 : 0.45;
      var diffToTarget = target.get() - location.get();
      target.subtract(diffToTarget * friction);
      if (!pointerDown && Math.abs(diffToTarget) < pullBackThreshold) {
        target.set(limit.constrain(target.get()));
        scrollBody.useSpeed(10).useMass(3);
      }
    }
    function toggleActive(active) {
      disabled = !active;
    }
    var self = {
      constrain,
      toggleActive
    };
    return self;
  }
  function ScrollContain(viewSize, contentSize, snaps, snapsAligned, containScroll) {
    var scrollBounds = Limit(-contentSize + viewSize, snaps[0]);
    var snapsBounded = snapsAligned.map(scrollBounds.constrain);
    var snapsContained = measureContained();
    function findDuplicates() {
      var startSnap = snapsBounded[0];
      var endSnap = arrayLast(snapsBounded);
      var min = snapsBounded.lastIndexOf(startSnap);
      var max = snapsBounded.indexOf(endSnap) + 1;
      return Limit(min, max);
    }
    function measureContained() {
      if (contentSize <= viewSize)
        return [scrollBounds.max];
      if (containScroll === "keepSnaps")
        return snapsBounded;
      var _a = findDuplicates(), min = _a.min, max = _a.max;
      return snapsBounded.slice(min, max);
    }
    var self = {
      snapsContained
    };
    return self;
  }
  function ScrollLimit(contentSize, scrollSnaps, loop) {
    var limit = measureLimit();
    function measureLimit() {
      var startSnap = scrollSnaps[0];
      var endSnap = arrayLast(scrollSnaps);
      var min = loop ? startSnap - contentSize : endSnap;
      var max = startSnap;
      return Limit(min, max);
    }
    var self = {
      limit
    };
    return self;
  }
  function ScrollLooper(contentSize, pxToPercent, limit, location, vectors) {
    var min = limit.min + pxToPercent.measure(0.1);
    var max = limit.max + pxToPercent.measure(0.1);
    var _a = Limit(min, max), reachedMin = _a.reachedMin, reachedMax = _a.reachedMax;
    function shouldLoop(direction) {
      if (direction === 1)
        return reachedMax(location.get());
      if (direction === -1)
        return reachedMin(location.get());
      return false;
    }
    function loop(direction) {
      if (!shouldLoop(direction))
        return;
      var loopDistance = contentSize * (direction * -1);
      vectors.forEach(function (v) {
        return v.add(loopDistance);
      });
    }
    var self = {
      loop
    };
    return self;
  }
  function ScrollProgress(limit) {
    var max = limit.max, scrollLength = limit.length;
    function get(n) {
      var currentLocation = n - max;
      return currentLocation / -scrollLength;
    }
    var self = {
      get
    };
    return self;
  }
  function ScrollSnap(axis, alignment, pxToPercent, containerRect, slideRects, slidesToScroll) {
    var startEdge = axis.startEdge, endEdge = axis.endEdge;
    var snaps = measureUnaligned();
    var snapsAligned = measureAligned();
    function measureSizes() {
      return groupArray(slideRects, slidesToScroll).map(function (rects) {
        return arrayLast(rects)[endEdge] - rects[0][startEdge];
      }).map(pxToPercent.measure).map(Math.abs);
    }
    function measureUnaligned() {
      return slideRects.map(function (rect) {
        return containerRect[startEdge] - rect[startEdge];
      }).map(pxToPercent.measure).map(function (snap) {
        return -Math.abs(snap);
      });
    }
    function measureAligned() {
      var groupedSnaps = groupArray(snaps, slidesToScroll).map(function (g) {
        return g[0];
      });
      var alignments = measureSizes().map(alignment.measure);
      return groupedSnaps.map(function (snap, index) {
        return snap + alignments[index];
      });
    }
    var self = {
      snaps,
      snapsAligned
    };
    return self;
  }
  function ScrollTarget(loop, scrollSnaps, contentSize, limit, targetVector) {
    var reachedAny = limit.reachedAny, removeOffset = limit.removeOffset, constrain = limit.constrain;
    function minDistance(d1, d2) {
      return Math.abs(d1) < Math.abs(d2) ? d1 : d2;
    }
    function findTargetSnap(target) {
      var distance = loop ? removeOffset(target) : constrain(target);
      var ascDiffsToSnaps = scrollSnaps.map(function (scrollSnap) {
        return scrollSnap - distance;
      }).map(function (diffToSnap) {
        return shortcut(diffToSnap, 0);
      }).map(function (diff, i) {
        return {
          diff,
          index: i
        };
      }).sort(function (d1, d2) {
        return Math.abs(d1.diff) - Math.abs(d2.diff);
      });
      var index = ascDiffsToSnaps[0].index;
      return {
        index,
        distance
      };
    }
    function shortcut(target, direction) {
      var t1 = target;
      var t2 = target + contentSize;
      var t3 = target - contentSize;
      if (!loop)
        return t1;
      if (!direction)
        return minDistance(minDistance(t1, t2), t3);
      var shortest = minDistance(t1, direction === 1 ? t2 : t3);
      return Math.abs(shortest) * direction;
    }
    function byIndex(index, direction) {
      var diffToSnap = scrollSnaps[index] - targetVector.get();
      var distance = shortcut(diffToSnap, direction);
      return {
        index,
        distance
      };
    }
    function byDistance(distance, snap) {
      var target = targetVector.get() + distance;
      var _a = findTargetSnap(target), index = _a.index, targetSnapDistance = _a.distance;
      var reachedBound = !loop && reachedAny(target);
      if (!snap || reachedBound)
        return {
          index,
          distance
        };
      var diffToSnap = scrollSnaps[index] - targetSnapDistance;
      var snapDistance = distance + shortcut(diffToSnap, 0);
      return {
        index,
        distance: snapDistance
      };
    }
    var self = {
      byDistance,
      byIndex,
      shortcut
    };
    return self;
  }
  function ScrollTo(animation, indexCurrent, indexPrevious, scrollTarget, targetVector, events) {
    function scrollTo(target) {
      var distanceDiff = target.distance;
      var indexDiff = target.index !== indexCurrent.get();
      if (distanceDiff) {
        animation.start();
        targetVector.add(distanceDiff);
      }
      if (indexDiff) {
        indexPrevious.set(indexCurrent.get());
        indexCurrent.set(target.index);
        events.emit("select");
      }
    }
    function distance(n, snap) {
      var target = scrollTarget.byDistance(n, snap);
      scrollTo(target);
    }
    function index(n, direction) {
      var targetIndex = indexCurrent.clone().set(n);
      var target = scrollTarget.byIndex(targetIndex.get(), direction);
      scrollTo(target);
    }
    var self = {
      distance,
      index
    };
    return self;
  }
  function SlideLooper(axis, viewSize, contentSize, slideSizesWithGaps, scrollSnaps, slidesInView, scrollLocation, slides) {
    var ascItems = arrayKeys(slideSizesWithGaps);
    var descItems = arrayKeys(slideSizesWithGaps).reverse();
    var loopPoints = startPoints().concat(endPoints());
    function removeSlideSizes(indexes, from) {
      return indexes.reduce(function (a, i) {
        return a - slideSizesWithGaps[i];
      }, from);
    }
    function slidesInGap(indexes, gap) {
      return indexes.reduce(function (a, i) {
        var remainingGap = removeSlideSizes(a, gap);
        return remainingGap > 0 ? a.concat([i]) : a;
      }, []);
    }
    function findLoopPoints(indexes, edge) {
      var isStartEdge = edge === "start";
      var offset = isStartEdge ? -contentSize : contentSize;
      var slideBounds = slidesInView.findSlideBounds(offset);
      return indexes.map(function (index) {
        var initial = isStartEdge ? 0 : -contentSize;
        var altered = isStartEdge ? contentSize : 0;
        var bounds = slideBounds.filter(function (b) {
          return b.index === index;
        })[0];
        var point = bounds[isStartEdge ? "end" : "start"];
        var getTarget = function getTarget2() {
          return scrollLocation.get() > point ? initial : altered;
        };
        return {
          point,
          getTarget,
          index,
          location: -1
        };
      });
    }
    function startPoints() {
      var gap = scrollSnaps[0] - 1;
      var indexes = slidesInGap(descItems, gap);
      return findLoopPoints(indexes, "end");
    }
    function endPoints() {
      var gap = viewSize - scrollSnaps[0] - 1;
      var indexes = slidesInGap(ascItems, gap);
      return findLoopPoints(indexes, "start");
    }
    function canLoop() {
      return loopPoints.every(function (_a) {
        var index = _a.index;
        var otherIndexes = ascItems.filter(function (i) {
          return i !== index;
        });
        return removeSlideSizes(otherIndexes, viewSize) <= 0;
      });
    }
    function loop() {
      loopPoints.forEach(function (loopPoint) {
        var getTarget = loopPoint.getTarget, location = loopPoint.location, index = loopPoint.index;
        var target = getTarget();
        if (target !== location) {
          slides[index].style[axis.startEdge] = target + "%";
          loopPoint.location = target;
        }
      });
    }
    function clear() {
      loopPoints.forEach(function (_a) {
        var index = _a.index;
        slides[index].style[axis.startEdge] = "";
      });
    }
    var self = {
      canLoop,
      clear,
      loop,
      loopPoints
    };
    return self;
  }
  function SlideFocus(rootNode, scrollTo, slidesToScroll) {
    var eventStore = EventStore();
    var removeAllEvents = eventStore.removeAll;
    var lastTabPressTime = 0;
    function registerTabPress(event) {
      if (event.keyCode !== 9)
        return;
      lastTabPressTime = new Date().getTime();
    }
    function addFocusEvent(slide, index) {
      var focus = function focus2() {
        var nowTime = new Date().getTime();
        var diffTime = nowTime - lastTabPressTime;
        if (diffTime > 10)
          return;
        rootNode.scrollLeft = 0;
        var selectedIndex = Math.floor(index / slidesToScroll);
        scrollTo.index(selectedIndex, 0);
      };
      eventStore.add(slide, "focus", focus, true);
    }
    function addActivationEvents(slides) {
      eventStore.add(document, "keydown", registerTabPress, false);
      slides.forEach(addFocusEvent);
    }
    var self = {
      addActivationEvents,
      removeAllEvents
    };
    return self;
  }
  function SlidesInView(viewSize, contentSize, slideSizes, snaps, loop, inViewThreshold) {
    var threshold = Math.min(Math.max(inViewThreshold, 0.01), 0.99);
    var offsets = loop ? [0, contentSize, -contentSize] : [0];
    var slideBounds = offsets.reduce(function (a, offset) {
      return a.concat(findSlideBounds(offset, threshold));
    }, []);
    function findSlideBounds(offset, threshold2) {
      var thresholds = slideSizes.map(function (s) {
        return s * (threshold2 || 0);
      });
      return snaps.map(function (snap, index) {
        return {
          start: snap - slideSizes[index] + thresholds[index] + offset,
          end: snap + viewSize - thresholds[index] + offset,
          index
        };
      });
    }
    function check(location) {
      return slideBounds.reduce(function (list, slideBound) {
        var index = slideBound.index, start = slideBound.start, end = slideBound.end;
        var inList = list.indexOf(index) !== -1;
        var inView = start < location && end > location;
        return !inList && inView ? list.concat([index]) : list;
      }, []);
    }
    var self = {
      check,
      findSlideBounds
    };
    return self;
  }
  function SlideSizes(axis, pxToPercent, slides, slideRects, loop) {
    var measureSize = axis.measureSize, startEdge = axis.startEdge, endEdge = axis.endEdge;
    var sizesInPx = slideRects.map(measureSize);
    var slideSizes = sizesInPx.map(pxToPercent.measure);
    var slideSizesWithGaps = measureWithGaps();
    function measureWithGaps() {
      return slideRects.map(function (rect, index, rects) {
        var isLast = index === lastIndex(rects);
        var style = window.getComputedStyle(arrayLast(slides));
        var endGap = parseFloat(style.getPropertyValue("margin-" + endEdge));
        if (isLast)
          return sizesInPx[index] + (loop ? endGap : 0);
        return rects[index + 1][startEdge] - rect[startEdge];
      }).map(pxToPercent.measure).map(Math.abs);
    }
    var self = {
      slideSizes,
      slideSizesWithGaps
    };
    return self;
  }
  function Translate(axis, direction, container) {
    var containerStyle = container.style;
    var translate = axis.scroll === "x" ? x : y;
    var disabled = false;
    function x(n) {
      return "translate3d(" + n + "%,0px,0px)";
    }
    function y(n) {
      return "translate3d(0px," + n + "%,0px)";
    }
    function to(target) {
      if (disabled)
        return;
      containerStyle.transform = translate(direction.applyTo(target.get()));
    }
    function toggleActive(active) {
      disabled = !active;
    }
    function clear() {
      containerStyle.transform = "";
    }
    var self = {
      clear,
      to,
      toggleActive
    };
    return self;
  }
  function Engine(root, container, slides, options2, events) {
    var align = options2.align, scrollAxis = options2.axis, contentDirection = options2.direction, startIndex = options2.startIndex, inViewThreshold = options2.inViewThreshold, loop = options2.loop, speed = options2.speed, dragFree = options2.dragFree, slidesToScroll = options2.slidesToScroll, skipSnaps = options2.skipSnaps, containScroll = options2.containScroll;
    var containerRect = container.getBoundingClientRect();
    var slideRects = slides.map(function (slide) {
      return slide.getBoundingClientRect();
    });
    var direction = Direction(contentDirection);
    var axis = Axis(scrollAxis, contentDirection);
    var pxToPercent = PxToPercent(axis.measureSize(containerRect));
    var viewSize = pxToPercent.totalPercent;
    var alignment = Alignment(align, viewSize);
    var _a = SlideSizes(axis, pxToPercent, slides, slideRects, loop), slideSizes = _a.slideSizes, slideSizesWithGaps = _a.slideSizesWithGaps;
    var _b = ScrollSnap(axis, alignment, pxToPercent, containerRect, slideRects, slidesToScroll), snaps = _b.snaps, snapsAligned = _b.snapsAligned;
    var contentSize = -arrayLast(snaps) + arrayLast(slideSizesWithGaps);
    var snapsContained = ScrollContain(viewSize, contentSize, snaps, snapsAligned, containScroll).snapsContained;
    var contain = !loop && containScroll !== "";
    var scrollSnaps = contain ? snapsContained : snapsAligned;
    var limit = ScrollLimit(contentSize, scrollSnaps, loop).limit;
    var index = Counter(lastIndex(scrollSnaps), startIndex, loop);
    var indexPrevious = index.clone();
    var slideIndexes = arrayKeys(slides);
    var update = function update2() {
      if (!loop)
        engine.scrollBounds.constrain(engine.dragHandler.pointerDown());
      engine.scrollBody.seek(target).update();
      var settled = engine.scrollBody.settle(target);
      if (settled && !engine.dragHandler.pointerDown()) {
        engine.animation.stop();
        events.emit("settle");
      }
      if (!settled) {
        events.emit("scroll");
      }
      if (loop) {
        engine.scrollLooper.loop(engine.scrollBody.direction());
        engine.slideLooper.loop();
      }
      engine.translate.to(location);
      engine.animation.proceed();
    };
    var animation = Animation(update);
    var startLocation = scrollSnaps[index.get()];
    var location = Vector1D(startLocation);
    var target = Vector1D(startLocation);
    var scrollBody = ScrollBody(location, speed, 1);
    var scrollTarget = ScrollTarget(loop, scrollSnaps, contentSize, limit, target);
    var scrollTo = ScrollTo(animation, index, indexPrevious, scrollTarget, target, events);
    var slidesInView = SlidesInView(viewSize, contentSize, slideSizes, snaps, loop, inViewThreshold);
    var dragHandler = DragHandler(axis, direction, root, target, dragFree, DragTracker(axis, pxToPercent), location, animation, scrollTo, scrollBody, scrollTarget, index, events, loop, skipSnaps);
    var engine = {
      animation,
      axis,
      direction,
      dragHandler,
      pxToPercent,
      index,
      indexPrevious,
      limit,
      location,
      options: options2,
      scrollBody,
      scrollBounds: ScrollBounds(limit, location, target, scrollBody),
      scrollLooper: ScrollLooper(contentSize, pxToPercent, limit, location, [location, target]),
      scrollProgress: ScrollProgress(limit),
      scrollSnaps,
      scrollTarget,
      scrollTo,
      slideFocus: SlideFocus(root, scrollTo, slidesToScroll),
      slideLooper: SlideLooper(axis, viewSize, contentSize, slideSizesWithGaps, scrollSnaps, slidesInView, location, slides),
      slidesInView,
      slideIndexes,
      target,
      translate: Translate(axis, direction, container)
    };
    return engine;
  }
  function EventEmitter() {
    var listeners = {};
    function getListeners(evt) {
      var eventListeners = listeners[evt];
      return eventListeners || [];
    }
    function emit(evt) {
      getListeners(evt).forEach(function (e) {
        return e(evt);
      });
      return self;
    }
    function on(evt, cb) {
      listeners[evt] = getListeners(evt).concat([cb]);
      return self;
    }
    function off(evt, cb) {
      listeners[evt] = getListeners(evt).filter(function (e) {
        return e !== cb;
      });
      return self;
    }
    var self = {
      emit,
      off,
      on
    };
    return self;
  }
  var defaultOptions = {
    align: "center",
    axis: "x",
    containScroll: "",
    direction: "ltr",
    dragFree: false,
    draggable: true,
    draggableClass: "is-draggable",
    draggingClass: "is-dragging",
    inViewThreshold: 0,
    loop: false,
    skipSnaps: true,
    selectedClass: "is-selected",
    slidesToScroll: 1,
    speed: 10,
    startIndex: 0
  };
  function OptionsPseudo(node) {
    var pseudoString = getComputedStyle(node, ":before").content;
    function get() {
      try {
        return JSON.parse(pseudoString.slice(1, -1).replace(/\\/g, ""));
      } catch (error) {
      }
      return {};
    }
    var self = {
      get
    };
    return self;
  }
  function EmblaCarousel(sliderRoot, userOptions) {
    var events = EventEmitter();
    var eventStore = EventStore();
    var debouncedResize = debounce(resize, 500);
    var reInit = reActivate;
    var on = events.on, off = events.off;
    var engine;
    var activated = false;
    var optionsBase = _extends({}, defaultOptions);
    var options2 = _extends({}, optionsBase);
    var optionsPseudo;
    var rootNodeSize = 0;
    var container;
    var slides;
    activate(userOptions);
    function setupElements() {
      if (!sliderRoot)
        throw new Error("Missing root node \u{1F622}");
      var sliderContainer = sliderRoot.querySelector("*");
      if (!sliderContainer)
        throw new Error("Missing container node \u{1F622}");
      container = sliderContainer;
      slides = Array.prototype.slice.call(container.children);
      optionsPseudo = OptionsPseudo(sliderRoot);
    }
    function activate(partialOptions) {
      setupElements();
      optionsBase = _extends({}, optionsBase, partialOptions);
      options2 = _extends({}, optionsBase, optionsPseudo.get());
      engine = Engine(sliderRoot, container, slides, options2, events);
      eventStore.add(window, "resize", debouncedResize);
      engine.translate.to(engine.location);
      rootNodeSize = engine.axis.measureSize(sliderRoot.getBoundingClientRect());
      if (options2.loop) {
        if (!engine.slideLooper.canLoop()) {
          deActivate();
          return activate({
            loop: false
          });
        }
        engine.slideLooper.loop();
      }
      if (options2.draggable && container.offsetParent && slides.length) {
        engine.dragHandler.addActivationEvents();
        if (options2.draggableClass) {
          addClass(sliderRoot, options2.draggableClass);
        }
        if (options2.draggingClass) {
          events.on("pointerDown", toggleDraggingClass).on("pointerUp", toggleDraggingClass);
        }
      }
      if (slides.length) {
        engine.slideFocus.addActivationEvents(slides);
      }
      if (options2.selectedClass) {
        toggleSelectedClass();
        events.on("select", toggleSelectedClass).on("pointerUp", toggleSelectedClass);
      }
      if (!activated) {
        setTimeout(function () {
          return events.emit("init");
        }, 0);
        activated = true;
      }
    }
    function toggleDraggingClass(evt) {
      var draggingClass = options2.draggingClass;
      if (evt === "pointerDown")
        addClass(sliderRoot, draggingClass);
      else
        removeClass(sliderRoot, draggingClass);
    }
    function toggleSelectedClass() {
      var selectedClass = options2.selectedClass;
      var inView = slidesInView(true);
      var notInView = slidesNotInView(true);
      notInView.forEach(function (index) {
        return removeClass(slides[index], selectedClass);
      });
      inView.forEach(function (index) {
        return addClass(slides[index], selectedClass);
      });
    }
    function deActivate() {
      engine.dragHandler.removeAllEvents();
      engine.slideFocus.removeAllEvents();
      engine.animation.stop();
      eventStore.removeAll();
      engine.translate.clear();
      engine.slideLooper.clear();
      removeClass(sliderRoot, options2.draggableClass);
      slides.forEach(function (slide) {
        return removeClass(slide, options2.selectedClass);
      });
      events.off("select", toggleSelectedClass).off("pointerUp", toggleSelectedClass).off("pointerDown", toggleDraggingClass).off("pointerUp", toggleDraggingClass);
    }
    function reActivate(partialOptions) {
      if (!activated)
        return;
      var startIndex = selectedScrollSnap();
      var newOptions = _extends({
        startIndex
      }, partialOptions);
      deActivate();
      activate(newOptions);
      events.emit("reInit");
    }
    function destroy() {
      if (!activated)
        return;
      deActivate();
      activated = false;
      events.emit("destroy");
    }
    function resize() {
      if (!activated)
        return;
      var size = engine.axis.measureSize(sliderRoot.getBoundingClientRect());
      if (rootNodeSize !== size)
        reActivate();
      events.emit("resize");
    }
    function slidesInView(target) {
      var location = engine[target ? "target" : "location"].get();
      var type = options2.loop ? "removeOffset" : "constrain";
      return engine.slidesInView.check(engine.limit[type](location));
    }
    function slidesNotInView(target) {
      var inView = slidesInView(target);
      return engine.slideIndexes.filter(function (index) {
        return inView.indexOf(index) === -1;
      });
    }
    function scrollTo(index, jump, direction) {
      engine.scrollBody.useBaseMass().useSpeed(jump ? 100 : options2.speed);
      if (activated)
        engine.scrollTo.index(index, direction || 0);
    }
    function scrollNext(jump) {
      var next = engine.index.clone().add(1);
      scrollTo(next.get(), jump === true, -1);
    }
    function scrollPrev(jump) {
      var prev = engine.index.clone().add(-1);
      scrollTo(prev.get(), jump === true, 1);
    }
    function canScrollNext() {
      var next = engine.index.clone().add(1);
      return next.get() !== selectedScrollSnap();
    }
    function canScrollPrev() {
      var prev = engine.index.clone().add(-1);
      return prev.get() !== selectedScrollSnap();
    }
    function scrollSnapList() {
      return engine.scrollSnaps.map(engine.scrollProgress.get);
    }
    function scrollProgress() {
      return engine.scrollProgress.get(engine.location.get());
    }
    function selectedScrollSnap() {
      return engine.index.get();
    }
    function previousScrollSnap() {
      return engine.indexPrevious.get();
    }
    function clickAllowed() {
      return engine.dragHandler.clickAllowed();
    }
    function dangerouslyGetEngine() {
      return engine;
    }
    function rootNode() {
      return sliderRoot;
    }
    function containerNode() {
      return container;
    }
    function slideNodes() {
      return slides;
    }
    var self = {
      canScrollNext,
      canScrollPrev,
      clickAllowed,
      containerNode,
      dangerouslyGetEngine,
      destroy,
      off,
      on,
      previousScrollSnap,
      reInit,
      rootNode,
      scrollNext,
      scrollPrev,
      scrollProgress,
      scrollSnapList,
      scrollTo,
      selectedScrollSnap,
      slideNodes,
      slidesInView,
      slidesNotInView
    };
    return self;
  }
  var embla_carousel_esm_default = EmblaCarousel;

  // app/scripts/common/quantitySelect.js
  var quantitySelect = class extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector("input");
      this.querySelectorAll("button").forEach((button) => button.addEventListener("click", this.onButtonClick.bind(this)));
    }
    onButtonClick(event) {
      event.preventDefault();
      const previousValue = this.input.value;
      event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
      this.input.dispatchEvent(new Event("change"));
    }
  };
  customElements.define("quantity-select", quantitySelect);

  // app/scripts/common/orderForm.js
  var orderForm = class extends HTMLElement {
    constructor() {
      super();
      this.querySelectorAll("input").forEach((i) => i.addEventListener("change", this.onChange.bind(this)));
      this.querySelector(".jsExpand").addEventListener("click", (e) => {
        e.preventDefault();
        this.classList.toggle("expanded");
      });
      this.submitBtn = this.querySelector(".jsSubmit");
      this.submitBtn.addEventListener("click", this.addBundleToCart.bind(this));
    }
    onChange() {
      let count = 0;
      this.itemList = [];
      this.submitBtn.setAttribute("disabled", "disabled");
      this.querySelectorAll("input").forEach((i) => {
        if (i.value > 0) {
          count += +i.value;
          this.itemList.push({
            id: i.dataset.id,
            quantity: +i.value
          });
          this.submitBtn.removeAttribute("disabled");
        }
      });
      this.querySelector(".jsCount").innerHTML = count;
    }
    addBundleToCart(e) {
      e.preventDefault();
      e.stopPropagation();
      this.submitBtn.setAttribute("disabled", "disabled");
      let formData = {
        "items": this.itemList
      };
      const currentText = this.submitBtn.innerHTML;
      this.submitBtn.innerHTML = "ADDING TO CART";
      fetch(this.dataset.cartAdd + ".js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(formData)
      }).then((response) => {
        response.json().then((e2) => {
          if (e2.status) {
            console.log(e2);
            alert(e2.description);
            return;
          }
          this.submitBtn.innerHTML = "SUCCESS!";
          setTimeout(() => {
            this.submitBtn.innerHTML = currentText;
            this.submitBtn.removeAttribute("disabled");
          }, 300);
          window.Cart.updateMiniCartUIAfterAddToCartV2(this.itemList);
        });
      }).catch((error) => {
        console.error("Error:", error);
      });
    }
  };
  customElements.define("order-form", orderForm);

  // app/scripts/common/productBundle.js
  var bundleItem = class extends HTMLElement {
    constructor() {
      super();
      this.init();
    }
    init() {
      this.JSON = JSON.parse(this.querySelector("script[type*=json]").innerHTML);
      this.querySelectorAll("[type=radio]").forEach((input) => {
        input.addEventListener("click", (e) => {
          input.checked = true;
          input.closest(".bundle__item-option").querySelector(".option-value").innerHTML = input.dataset.value;
          this.classList.toggle("selected", this.querySelectorAll(".bundle__item-option").length == this.querySelectorAll("[type=radio]:not([disabled]):checked").length);
        });
      });
      this.filterOption();
    }
    updateVariantImage(variant) {
      const featuredImg = this.querySelector(".bundle__item-image img");
      if (!variant) {
        const selectOptions = [];
        [...this.querySelectorAll("[type=radio]:checked")].forEach((item) => {
          selectOptions.push({
            option: item.dataset.option,
            value: item.value
          });
        });
        variant = Array.from(this.JSON.variants).find((i) => {
          return selectOptions.every((j) => {
            return i[j.option] == j.value;
          });
        });
      }
      if (!featuredImg || !variant || !variant.featured_image)
        return;
      featuredImg.classList.remove("lazyloaded", "lazyautosizes");
      featuredImg.removeAttribute("data-srcset");
      featuredImg.removeAttribute("srcset");
      featuredImg.setAttribute("data-src", variant.featured_image.src);
      featuredImg.classList.add("lazyload");
    }
    getVariant() {
      const selectOption = [];
      [...this.querySelectorAll("[type=radio]:checked")].forEach((item) => {
        selectOption.push(item.value);
      });
      this.variant = Array.from(this.JSON.variants).find((i) => {
        return JSON.stringify(i.options) == JSON.stringify(selectOption);
      });
      this.updateVariantImage(this.variant);
    }
    setOption(value) {
      const input = this.querySelector(`[value="${value}"]`);
      if (!input)
        return;
      input.dispatchEvent(new Event("click"));
      this.dispatchEvent(new Event("change"));
    }
    filterOption() {
      const selectedOption = Array.from(this.querySelectorAll(".bundle__item-option--color [type=radio]:checked")).map((i) => i.value);
      const variantList = this.JSON.variants;
      let availableOptions = [];
      selectedOption.forEach((value, index) => {
        let option = "option" + (index + 1);
        const availableVariantList = variantList.filter((v) => {
          return v.available && v.options.includes(value);
        });
        availableOptions.push(availableVariantList.map((i) => i.options));
      });
      availableOptions = [...new Set(availableOptions.flat(2))];
      Array.from(this.querySelectorAll(`.bundle__item-option:not(.bundle__item-option--color) input`)).forEach((input) => {
        availableOptions.includes(input.value) ? input.removeAttribute("disabled") : input.setAttribute("disabled", "disabled");
      });
    }
  };
  !!!customElements.get("bundle-item-component") && customElements.define("bundle-item-component", bundleItem);
  var bundleGroup = class extends HTMLElement {
    constructor() {
      super();
      this.addBundleToCartBtn = this.querySelector(".js-add-bundle");
      this.querySelectorAll(".js-close").forEach((i) => {
        i.addEventListener("click", (e) => {
          e.preventDefault();
          i.closest(".js-modal").classList.remove("active");
        });
      });
      this.querySelectorAll(".js-bundleOpen").forEach((i) => {
        i.addEventListener("click", (e) => {
          const target = this.querySelector(i.dataset.id);
          if (!target)
            return;
          this.querySelectorAll(".js-modal.active")?.forEach((modal) => modal.classList.remove("active"));
          target.classList.add("active");
        });
      });
    }
    connectedCallback() {
      const bundleItemList = this.querySelectorAll("bundle-item-component");
      this.bundleItemLength = bundleItemList.length;
      this.itemList = [];
      bundleItemList.length && bundleItemList.forEach((item, index) => {
        item.addEventListener("change", (e) => {
          this.enableAddBundleToCart();
          item.getVariant();
          item.filterOption(item.variant);
          if (item.variant && item.variant.available) {
            this.itemList[index] = {
              id: item.variant.id,
              quantity: 1,
              properties: item.variant.properties || {}
            };
          }
          ;
        });
      });
      this.querySelectorAll(".js-bundle-option").forEach((option) => {
        option.addEventListener("change", (e) => {
          this.querySelector(".js-option-value").innerHTML = option.value;
          bundleItemList.forEach((i) => {
            i.setOption(option.value);
          });
        });
      });
      this.addBundleToCartBtn && this.addBundleToCartBtn.addEventListener("click", this.addBundleToCart.bind(this));
    }
    enableAddBundleToCart() {
      const isValid = this.bundleItemLength == this.querySelectorAll("bundle-item-component.selected").length;
      this.addBundleToCartBtn.removeAttribute("disabled");
      this.addBundleToCartBtn.classList.toggle("disabled", !isValid);
      isValid && this.classList.remove("show-warning-msg");
    }
    addBundleToCart(e) {
      e.preventDefault();
      e.stopPropagation();
      if (this.addBundleToCartBtn.classList.contains("disabled")) {
        this.classList.add("show-warning-msg");
        return;
      }
      let formData = {
        "items": this.itemList
      };
      this.addBundleToCartBtn.classList.add("opacity-60", "pointer-events-none");
      this.addBundleToCartBtn.innerHTML = "ADDING TO CART";
      fetch(this.dataset.cartAdd + ".js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(formData)
      }).then((response) => {
        response.json().then((e2) => {
          if (e2.status) {
            console.log(e2);
            alert(e2.description);
            return;
          }
          this.addBundleToCartBtn.innerHTML = "SUCCESS!";
          setTimeout(() => {
            this.addBundleToCartBtn.classList.remove("opacity-60", "pointer-events-none");
            this.addBundleToCartBtn.innerHTML = "ADD TO CART";
          }, 300);
          window.Cart.updateMiniCartUIAfterAddToCartV2(this.itemList);
        });
      }).catch((error) => {
        console.error("Error:", error);
      });
    }
  };
  !!!customElements.get("bundle-component") && customElements.define("bundle-component", bundleGroup);

  // node_modules/@shopify/theme-product-form/listeners.js
  function Listeners() {
    this.entries = [];
  }
  Listeners.prototype.add = function (element, event, fn) {
    this.entries.push({ element, event, fn });
    element.addEventListener(event, fn);
  };
  Listeners.prototype.removeAll = function () {
    this.entries = this.entries.filter(function (listener) {
      listener.element.removeEventListener(listener.event, listener.fn);
      return false;
    });
  };

  // node_modules/@shopify/theme-product/theme-product.js
  function getVariantFromSerializedArray(product, collection) {
    _validateProductStructure(product);
    var optionArray = _createOptionArrayFromOptionCollection(product, collection);
    return getVariantFromOptionArray(product, optionArray);
  }
  function getVariantFromOptionArray(product, options2) {
    _validateProductStructure(product);
    _validateOptionsArray(options2);
    var result = product.variants.filter(function (variant) {
      return options2.every(function (option, index) {
        return variant.options[index] === option;
      });
    });
    return result[0] || null;
  }
  function _createOptionArrayFromOptionCollection(product, collection) {
    _validateProductStructure(product);
    _validateSerializedArray(collection);
    var optionArray = [];
    collection.forEach(function (option) {
      for (var i = 0; i < product.options.length; i++) {
        if (product.options[i].name.toLowerCase() === option.name.toLowerCase()) {
          optionArray[i] = option.value;
          break;
        }
      }
    });
    return optionArray;
  }
  function _validateProductStructure(product) {
    if (typeof product !== "object") {
      throw new TypeError(product + " is not an object.");
    }
    if (Object.keys(product).length === 0 && product.constructor === Object) {
      throw new Error(product + " is empty.");
    }
  }
  function _validateSerializedArray(collection) {
    if (!Array.isArray(collection)) {
      throw new TypeError(collection + " is not an array.");
    }
    if (collection.length === 0) {
      return [];
    }
    if (collection[0].hasOwnProperty("name")) {
      if (typeof collection[0].name !== "string") {
        throw new TypeError("Invalid value type passed for name of option " + collection[0].name + ". Value should be string.");
      }
    } else {
      throw new Error(collection[0] + "does not contain name key.");
    }
  }
  function _validateOptionsArray(options2) {
    if (Array.isArray(options2) && typeof options2[0] === "object") {
      throw new Error(options2 + "is not a valid array of options.");
    }
  }

  // node_modules/@shopify/theme-product-form/theme-product-form.js
  var selectors = {
    idInput: '[name="id"]',
    optionInput: '[name^="options"]',
    quantityInput: '[name="quantity"]',
    propertyInput: '[name^="properties"]'
  };
  function getUrlWithVariant(url, id) {
    if (/variant=/.test(url)) {
      return url.replace(/(variant=)[^&]+/, "$1" + id);
    } else if (/\?/.test(url)) {
      return url.concat("&variant=").concat(id);
    }
    return url.concat("?variant=").concat(id);
  }
  function ProductForm(element, product, options2) {
    this.element = element;
    this.product = _validateProductObject(product);
    options2 = options2 || {};
    this._listeners = new Listeners();
    this._listeners.add(this.element, "submit", this._onSubmit.bind(this, options2));
    this.optionInputs = this._initInputs(selectors.optionInput, options2.onOptionChange);
    this.quantityInputs = this._initInputs(selectors.quantityInput, options2.onQuantityChange);
    this.propertyInputs = this._initInputs(selectors.propertyInput, options2.onPropertyChange);
  }
  ProductForm.prototype.destroy = function () {
    this._listeners.removeAll();
  };
  ProductForm.prototype.options = function () {
    return _serializeOptionValues(this.optionInputs, function (item) {
      var regex = /(?:^(options\[))(.*?)(?:\])/;
      item.name = regex.exec(item.name)[2];
      return item;
    });
  };
  ProductForm.prototype.variant = function () {
    return getVariantFromSerializedArray(this.product, this.options());
  };
  ProductForm.prototype.properties = function () {
    var properties = _serializePropertyValues(this.propertyInputs, function (propertyName) {
      var regex = /(?:^(properties\[))(.*?)(?:\])/;
      var name = regex.exec(propertyName)[2];
      return name;
    });
    return Object.entries(properties).length === 0 ? null : properties;
  };
  ProductForm.prototype.quantity = function () {
    return this.quantityInputs[0] ? Number.parseInt(this.quantityInputs[0].value, 10) : 1;
  };
  ProductForm.prototype._setIdInputValue = function (value) {
    var idInputElement = this.element.querySelector(selectors.idInput);
    if (!idInputElement) {
      idInputElement = document.createElement("input");
      idInputElement.type = "hidden";
      idInputElement.name = "id";
      this.element.appendChild(idInputElement);
    }
    idInputElement.value = value.toString();
  };
  ProductForm.prototype._onSubmit = function (options2, event) {
    event.dataset = this._getProductFormEventData();
    if (event.dataset.variant) {
      this._setIdInputValue(event.dataset.variant.id);
    }
    if (options2.onFormSubmit) {
      options2.onFormSubmit(event);
    }
  };
  ProductForm.prototype._onFormEvent = function (cb) {
    if (typeof cb === "undefined") {
      return Function.prototype;
    }
    return function (event) {
      event.dataset = this._getProductFormEventData();
      cb(event);
    }.bind(this);
  };
  ProductForm.prototype._initInputs = function (selector, cb) {
    var elements = Array.prototype.slice.call(this.element.querySelectorAll(selector));
    return elements.map(function (element) {
      this._listeners.add(element, "change", this._onFormEvent(cb));
      return element;
    }.bind(this));
  };
  ProductForm.prototype._getProductFormEventData = function () {
    return {
      options: this.options(),
      variant: this.variant(),
      properties: this.properties(),
      quantity: this.quantity()
    };
  };
  function _serializeOptionValues(inputs, transform) {
    return inputs.reduce(function (options2, input) {
      if (input.checked || input.type !== "radio" && input.type !== "checkbox") {
        options2.push(transform({ name: input.name, value: input.value }));
      }
      return options2;
    }, []);
  }
  function _serializePropertyValues(inputs, transform) {
    return inputs.reduce(function (properties, input) {
      if (input.checked || input.type !== "radio" && input.type !== "checkbox") {
        properties[transform(input.name)] = input.value;
      }
      return properties;
    }, {});
  }
  function _validateProductObject(product) {
    if (typeof product !== "object") {
      throw new TypeError(product + " is not an object.");
    }
    if (typeof product.variants[0].options === "undefined") {
      throw new TypeError("Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route");
    }
    return product;
  }

  // app/scripts/product.js
  var formElement = document.querySelector("[data-product-handle]");
  var moneyFormat = document.querySelector(".product_form").getAttribute("data-money-format");
  var cartButton = document.getElementById("AddToCart");
  var swatchElement = document.querySelectorAll(".swatch-element");
  var swatchElementSize = document.querySelectorAll(".swatch-element:not(.color");
  var swatchElementColor = document.querySelectorAll(".swatch-element.color");
  var productHandle = formElement.dataset.productHandle;
  fetch(`/products/${productHandle}.js`).then((response) => {
    return response.json();
  }).then((productJSON) => {
    const variants = productJSON.variants;
    const productOptions = productJSON.options;
    const availableVariantColors = [];
    const availableVariantSizes = [];
    for (const variant of variants) {
      if (variant.available) {
        if (productOptions[0].name === "Color") {
          availableVariantColors.push(variant.option1);
          availableVariantSizes.push(variant.option2);
        } else {
          availableVariantColors.push(variant.option2);
          availableVariantSizes.push(variant.option1);
        }
      }
    }
    const firstAvailableColorValue = document.querySelector('select[name="options[Color]"]')?.value || "";
    for (const color of swatchElementColor) {
      if (color.getAttribute("data-value") === firstAvailableColorValue) {
        removeClassLoop(swatchElementColor, "swatch-active-color");
        color.classList.toggle("swatch-active-color");
        color.classList.remove("border-none");
        color.previousElementSibling.checked = true;
        const variantImages = Array.from(document.querySelectorAll(".embla__slide__thumbnail"));
        variantImages.forEach((image) => {
          if (image.dataset.imageId === color.getAttribute("data-featured-image")) {
            image.click();
          }
        });
      }
    }
    const productForm = new ProductForm(formElement, productJSON, {
      onOptionChange
    });
    const currentOptions = productForm.options();
  }).catch((error) => {
    console.log(error);
  });
  function onOptionChange(event) {
    try {
      const variant = event.dataset.variant;
      if (variant === null) {
      } else if (variant && !variant.available) {
      } else if (variant && variant.available) {
      }
      if (!variant)
        return;
      const url = getUrlWithVariant(window.location.href, variant.id);
      window.history.replaceState({ path: url }, "", url);
    } catch (error) {
      console.error(`error using variant onOptionChange: ${error}`);
    }
  }
  function removeClassLoop(DOMelement, activeClass) {
    try {
      DOMelement.forEach((element) => {
        element.classList.remove(activeClass);
      });
    } catch (error) {
      console.error(`error removing a class: ${error}`);
    }
  }
  function variantImageSelect() {
    try {
      const featuredVariantImageID = this.getAttribute("data-featured-image");
      const variantImages = Array.from(document.querySelectorAll(".embla__slide__thumbnail"));
      variantImages.every((image) => {
        if (image.dataset.imageId === featuredVariantImageID) {
          image.click();
          return false;
        }
        return true;
      });
    } catch (error) {
      console.log(`Variant image selection function ${error}`);
    }
  }
  swatchElementColor.forEach((swatch) => {
    swatch.addEventListener("click", variantImageSelect);
  });
  var mainCarouselWrap = document.getElementById("main-carousel");
  var mainCarouselView = mainCarouselWrap.querySelector(".embla__viewport");
  var prevBtn = mainCarouselWrap.querySelector(".embla__button--prev");
  var nextBtn = mainCarouselWrap.querySelector(".embla__button--next");
  var options = { selectedClass: "", loop: false };
  var mainCarousel = embla_carousel_esm_default(mainCarouselView, options);
  var thumbCarouselWrap = document.getElementById("thumb-carousel");
  var thumbCarouselView = thumbCarouselWrap.querySelector(".embla__viewport");
  var thumbCarousel = embla_carousel_esm_default(thumbCarouselView, {
    selectedClass: "",
    containScroll: "keepSnaps"
  });
  var onThumbClick = (carousel, thumbnailCarousel, index) => () => {
    if (!thumbCarousel.clickAllowed())
      return;
    mainCarousel.scrollTo(index);
  };
  var selectThumbBtn = (carousel, thumbnailCarousel) => {
    const previous = mainCarousel.previousScrollSnap();
    const selected = mainCarousel.selectedScrollSnap();
    thumbCarousel.slideNodes()[previous].classList.remove("is-selected");
    thumbCarousel.slideNodes()[selected].classList.add("is-selected");
  };
  var followMainCarousel = (carousel, thumbnailCarousel) => () => {
    thumbCarousel.scrollTo(mainCarousel.selectedScrollSnap());
    selectThumbBtn(mainCarousel, thumbCarousel);
  };
  thumbCarousel.slideNodes().forEach((thumbNode, index) => {
    const onClick = onThumbClick(mainCarousel, thumbCarousel, index);
    thumbNode.addEventListener("click", onClick, false);
  });
  var syncThumbCarousel = followMainCarousel(mainCarousel, thumbCarousel);
  mainCarousel.on("select", syncThumbCarousel);
  thumbCarousel.on("init", syncThumbCarousel);
  var lazyLoad = (carousel) => {
    const slides = mainCarousel.slideNodes();
    const images = slides.map((slide) => slide.querySelector(".embla__slide__img"));
    const imagesInView = [];
    const addImageLoadEvent = (image, callback) => {
      image.addEventListener("load", callback);
      return () => image.removeEventListener("load", callback);
    };
    const loadImageInView = (index) => {
      const image = images[index];
      const slide = slides[index];
      imagesInView.push(index);
      image.src = image.getAttribute("data-src");
      const removeImageLoadEvent = addImageLoadEvent(image, () => {
        slide.classList.add("has-loaded");
        removeImageLoadEvent();
      });
    };
    const loadImagesInView2 = () => {
      mainCarousel.slidesInView(true).filter((index) => imagesInView.indexOf(index) === -1).forEach(loadImageInView);
    };
    return () => {
      loadImagesInView2();
      return imagesInView.length === images.length;
    };
  };
  var loadImagesInView = lazyLoad(mainCarousel);
  var loadImagesInViewAndDestroyIfDone = (eventName) => {
    const loadedAll = loadImagesInView();
    if (loadedAll)
      mainCarousel.off(eventName, loadImagesInViewAndDestroyIfDone);
  };
  mainCarousel.on("init", loadImagesInViewAndDestroyIfDone);
  mainCarousel.on("select", loadImagesInViewAndDestroyIfDone);
  mainCarousel.on("resize", loadImagesInViewAndDestroyIfDone);
  var setupPrevNextBtns = (prevButtton, nextButtton, carousel) => {
    prevBtn.addEventListener("click", mainCarousel.scrollPrev, false);
    nextBtn.addEventListener("click", mainCarousel.scrollNext, false);
  };
  var disablePrevNextBtns = (prevButtton, nexButton, carousel) => {
    return () => {
      if (mainCarousel.canScrollPrev())
        prevBtn.removeAttribute("disabled");
      else
        prevBtn.setAttribute("disabled", true);
      if (mainCarousel.canScrollNext())
        nextBtn.removeAttribute("disabled");
      else
        nextBtn.setAttribute("disabled", "disabled");
    };
  };
  var disablePrevAndNextBtns = disablePrevNextBtns(prevBtn, nextBtn, mainCarousel);
  setupPrevNextBtns(prevBtn, nextBtn, mainCarousel);
  mainCarousel.on("select", disablePrevAndNextBtns);
  mainCarousel.on("init", disablePrevAndNextBtns);
  window.addEventListener("DOMContentLoaded", () => {
    const productTabs = Array.from(document.querySelectorAll(".product-tab"));
    const productTabContent = Array.from(document.querySelectorAll(".tab-content"));
    function rotateArrow() {
      const tabArrow = this.querySelector("img");
      if (tabArrow) {
        tabArrow.classList.toggle("transform");
        tabArrow.classList.toggle("rotate-90");
      }
    }
    productTabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        const tabName = tab.getAttribute("id");
        const content = document.getElementById(`${tabName}-content`);
        productTabContent.forEach((tabContent) => {
          if (!tabContent.classList.contains("hidden"))
            tabContent.classList.add("hidden");
          if (tabContent.classList.contains("lg:block")) {
            tabContent.classList.add("hidden");
            tabContent.classList.remove("lg:block");
          }
        });
        productTabs.forEach((tabTitle) => {
          tabTitle.classList.remove("border-b");
          tabTitle.classList.remove("lg:border-b");
        });
        content.classList.remove("hidden");
        tab.classList.add("border-b");
      });
    });
    const productRecSkeleton = document.getElementById("product-recs-skeleton-wrapper");
    if (productRecSkeleton) {
      productRecSkeleton.classList.add("hidden");
    }
  });
  var desktopFitSizeLink = document.getElementById("desktop-size-guide-link");
  var desktopFitSizeSection = document.getElementById("product-size-guide-desktop");
  if (desktopFitSizeLink) {
    desktopFitSizeLink.addEventListener("click", () => {
      desktopFitSizeSection.scrollIntoView({ behavior: "smooth", block: "nearest" });
      ;
    });
  }
  var stickyCartButton = document.querySelector(".sticky-cart-button");
  var singleCartButton = document.querySelector(".purchase-details");
  window.addEventListener("scroll", () => {
    if (singleCartButton.getBoundingClientRect().top <= 0) {
      stickyCartButton.classList.remove("opacity-0");
      stickyCartButton.classList.remove("h-0");
      stickyCartButton.classList.add("opacity-100");
    } else {
      stickyCartButton.classList.add("opacity-0");
      stickyCartButton.classList.add("h-0");
      stickyCartButton.classList.remove("opacity-100");
    }
  });
})();
